import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const RadioStyle = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  outline: 0;

  .radio-option {
    display: flex;
    transition: 0.3s ease-in-out all;
    position: relative;
    label {
      display: flex;
      cursor: pointer;
    }

    input {
      display: none;
      /* margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;

      &:hover + .radio-item {
        border: 1px solid ${(props) => props.theme.primary.primary50};
        background: ${theme.primary.primary10};
      } */
    }

    &:hover {
      .checkbox-item {
        border: 1px solid ${(props) => props.theme.primary.primary50};
      }

      .checkbox-label {
        color: ${(props) => props.theme.primary.primary50};
      }
    }

    &.active {
      input {
        &:hover + .radio-item {
          background: ${(props) => props.theme.primary.primary40};
        }
      }
      .radio-item {
        border: 1px solid ${(props) => props.theme.primary.primary50};
        background: ${(props) => props.theme.primary.primary50};

        &__circle {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
  .radio-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: 2px 0;
    margin-right: 8px;
    padding: 4px;
    border: 1px solid ${(props) => props.theme.primary.primary20};
    transition: 0.3s ease-in-out all;
    border-radius: 100%;
    cursor: pointer;
    background: white;

    &__circle {
      width: 100%;
      background: white;
      height: 100%;
      border-radius: 100%;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s ease-in-out all;
    }
  }

  .radio-label {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    transition: 0.3s ease-in-out all;
    margin-right: 16px;
  }
`;
